<div class="tositteen-muokkaus-page">
  <form novalidate autocomplete="kirjanpitoaineistoarkki">
    <div class="blue-background">
      <div style="margin-left: auto; margin-right: auto">
        <div class="ylapalkki">
          <button class="sulje" mat-button (click)="peruuta()" type="button">
            <i style="font-size: 60px; width: 60px; height: 60px; line-height: 60px; display: inline-block" class="icon ion-md-arrow-back"></i>
          </button>

          <h2 style="margin: 0; width: calc(100% - 18vw); text-align: center">
            {{ 'kuitit.muokkaa.otsikko-muokkaa' | translate | async }}
          </h2>
        </div>
      </div>
    </div>

    <div class="kuitti-container">
      <div class="tosite-container">
        <div class="tosite-tiedot">
          @if (showMaksutavat) {
            <div class="mat-form-field" style="font-size: 10.5px">{{ 'kuitit.muokkaa.laji' | translate | async }} *</div>
            <div style="padding-bottom: 5px">
              <app-kuitit-maksutapa [formField]="maksutapa" [showAllPaymentMethods]="true" [filterNonActive]="true" [error]="virheet(maksutapa)?.length"></app-kuitit-maksutapa>
              @if (virheet(maksutapa)?.required && (maksutapa().dirty() || maksutapa().touched())) {
                <mat-error>
                  {{ 'kuitit.muokkaa.validation.maksutapa.required' | translate | async }}
                </mat-error>
              }
            </div>
          }

          @if (showPvm) {
            @if (dateSelectionType === 'day') {
              <mat-form-field>
                <mat-label>{{ pvmText }}</mat-label>
                <input numberDatePicker matInput [formField]="tositteenPvm" [matDatepicker]="pickerDay" [min]="minDate" [max]="maxDate" autocomplete="1" data-lpignore="true" />
                @if (tositteenPvm; as n) {
                  @if (n().dirty() || n().touched()) {
                    @if (virheet(n)?.required) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.pvm.required' | translate | async }}</mat-error>
                    }
                    @if (virheet(n)?.matDatepickerParse) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerParse' | translate | async }}</mat-error>
                    }
                    @if (virheet(n)?.matDatepickerMax) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMax' | translate | async }}</mat-error>
                    }
                    @if (virheet(n)?.matDatepickerMin) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMin' | translate | async }}</mat-error>
                    }
                  }
                }
                <mat-datepicker-toggle matSuffix [for]="pickerDay"></mat-datepicker-toggle>
                <mat-datepicker #pickerDay></mat-datepicker>
              </mat-form-field>
            } @else {
              <mat-form-field>
                <mat-label>{{ pvmText }}</mat-label>
                <input monthPicker numberDatePicker matInput [formField]="tositteenPvm" [matDatepicker]="pickerMonth" [min]="minDate" [max]="maxDate" autocomplete="1" data-lpignore="true" />
                @if (tositteenPvm; as n) {
                  @if (n().dirty() || n().touched()) {
                    @if (virheet(n)?.required) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.pvm.required' | translate | async }}</mat-error>
                    }
                    @if (virheet(n)?.matDatepickerParse) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerParse' | translate | async }}</mat-error>
                    }
                    @if (virheet(n)?.matDatepickerMax) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMax' | translate | async }}</mat-error>
                    }
                    @if (virheet(n)?.matDatepickerMin) {
                      <mat-error>{{ 'kuitit.muokkaa.validation.pvm.matDatepickerMin' | translate | async }}</mat-error>
                    }
                  }
                }
                <mat-datepicker-toggle matSuffix [for]="pickerMonth"></mat-datepicker-toggle>
                <mat-datepicker #pickerMonth></mat-datepicker>
              </mat-form-field>
            }
          }

          <br />

          @if (!hideSum) {
            <mat-form-field>
              <mat-label>{{ summaText }}</mat-label>
              <input class="alignLeft" decimalNumberField matInput [formField]="summa" autocomplete="1" data-lpignore="true" />
              @if (virheet(summa)?.required && (summa().dirty() || summa().touched())) {
                <mat-error>
                  {{ 'kuitit.muokkaa.validation.summa.required' | translate | async }}
                </mat-error>
              }
              @if (virheet(summa)?.min && (summa().dirty() || summa().touched())) {
                <mat-error>
                  {{ 'kuitit.muokkaa.validation.summa.min' | translate: { min: virheet(summa).min.min | ldecimal: 2 | async } | async }}
                </mat-error>
              }
              @if (virheet(summa)?.max && (summa().dirty() || summa().touched())) {
                <mat-error>
                  {{ 'kuitit.muokkaa.validation.summa.max' | translate: { max: virheet(summa).max.max | ldecimal: 2 | async } | async }}
                </mat-error>
              }
            </mat-form-field>
          }

          <br />

          @if (alvPortaat) {
            <div>
              <mat-form-field>
                <mat-label>{{ 'kuitit.muokkaa.alv' | translate | async }}</mat-label>
                <mat-select [formField]="alvVahennysoikeus">
                  @for (porras of alvPortaat; track porras) {
                    <mat-option [value]="porras"> {{ porras }} % </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <br />
            </div>
          }

          @if (maksajaTaiMaksunSaaja) {
            <div class="el-kommentti">{{ maksajaTaiMaksunSaaja }}</div>
          }

          <mat-form-field>
            <mat-label>{{ 'kuitit.muokkaa.lisatiedot' | translate | async }}</mat-label>
            <textarea matInput [formField]="lisatiedot" cdkTextareaAutosize cdkAutosizeMinRows="1.5" cdkAutosizeMaxRows="35" autocomplete="1"></textarea>
          </mat-form-field>

          @if (kirjanpitajanKommentti) {
            <div class="kirj-kommentti">{{ 'kuitit.muokkaa.kirjanpitajan-kommentti' | translate | async }}: {{ kirjanpitajanKommentti }}</div>
          }
          @if (kuitti.userApiMessage) {
            <div class="tosite-api-msg" style="margin-top: 1em">{{ kuitti.userApiMessage }}</div>
          }

          <div class="button-container">
            <div>
              @if (virheviestiEiKuvia) {
                <div class="error-text" style="padding-bottom: 2em">
                  {{ virheviestiEiKuvia }}
                </div>
              }

              @if (virheviestiLatausOnKesken) {
                <div class="error-text" style="padding-bottom: 2em">
                  {{ virheviestiLatausOnKesken }}
                </div>
              }

              @if (virheviestiPysyva) {
                <div class="error-text" style="padding-bottom: 2em">
                  {{ virheviestiPysyva }}
                </div>
              }

              @if (virheviestiTallennus) {
                <div class="error-text" style="padding-bottom: 2em">
                  {{ virheviestiTallennus }}
                </div>
              }

              @if ((latausvirheetObservable | async)?.length > 0) {
                <div class="error-text" style="padding-bottom: 2em; text-align: left">
                  {{ 'lasku.tiedoston-lahettaminen-epaonnistui-alku' | translate | async }}
                  <ul>
                    @for (virhe of latausvirheetObservable | async; track virhe) {
                      <li>{{ virhe }}</li>
                    }
                  </ul>
                  {{ 'lasku.tiedoston-lahettaminen-epaonnistui-loppu' | translate | async }}
                </div>
              }

              <button class="primarybutton" mat-button (click)="save()">{{ 'yleiset.tallenna' | translate | async }}</button>
              <br />

              @if ((latausvirheetObservable | async)?.length && (donePercentageObservable | async) !== null) {
                <div style="width: 50%; margin-top: 2em; text-align: center; display: inline-block">
                  <mat-progress-bar mode="determinate" [value]="donePercentageObservable | async"></mat-progress-bar>
                  <div style="padding-top: 3px; font-size: 12px">{{ 'kuitit.muokkaa.ladataan' | translate | async }}</div>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="images-container">
          @for (kuva of kuvatDisplay; track kuva) {
            <div class="mat-elevation-z4 image-box">
              <div app-tosite-kuva [url]="kuva.url" [expandable]="true" style="width: 100%; height: 100%; position: relative"></div>
              @if (!kuva.lukittu) {
                <button class="poista-btn mat-elevation-z4" mat-icon-button (click)="poistaKuva(kuva)" type="button">
                  <mat-icon class="poista-icon">close</mat-icon>
                </button>
              }
            </div>
          }

          @for (pdfData of pdfKuvatDisplay; track pdfData) {
            <div>
              <app-tositteen-pdf-images-box [inputPdfData]="pdfData.kuvat" [lukittu]="pdfData.lukittu" (poistaKuvat)="poistaPdf(pdfData)"></app-tositteen-pdf-images-box>
            </div>
          }

          <div class="drag-box" (click)="uploadKuva()" [class.dragging-active]="(isDraggingObservable | async) || droppi.isDraggingOverDropZone" [class.dragging-passive]="!(isDraggingObservable | async) && !droppi.isDraggingOverDropZone">
            <app-file-drop #droppi dropZoneClassName="drag-area" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" (onFileDrop)="fileDrop($event)">
              <ng-template app-file-drop-content-tmp let-openFileSelector="uploadKuva">
                <div class="drag-text-and-icon" [class.blue-text]="(isDraggingObservable | async) || droppi.isDraggingOverDropZone">
                  <div class="drag-box-text">{{ 'kuitit.muokkaa.lisaa-tiedosto' | translate | async }}</div>
                  <i class="fa fa-arrow-down drag-box-icon"></i>
                </div>
              </ng-template>
            </app-file-drop>
          </div>
          @if (kuvavirheAvain) {
            <div class="red-text" style="text-align: center">{{ kuvavirheAvain | translate: kuvavirheParametrit | async }}</div>
          }
        </div>
      </div>
    </div>
  </form>
</div>

<input style="visibility: hidden; height: 1px" (change)="fileChanged($event)" type="file" accept="image/*,application/pdf,image/heic" #fileInput multiple="multiple" />
